module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//1.jpg?ab7066f5b90b57ae2fdfd2460881efae";